<template>
  <div class="equ-show">
    <div class="title" style="width: 60%;">
      <div class="title-text">设备展示</div>
    </div>
    <div class="list">
      <div :class="show == 0 ? 'list-item choosen' : 'list-item'" @click="sbclick(0)">
        <img
          :src="show == 0 ?require('../../assets/equipment/all-nav.png'):require('../../assets/equipment/all.png')"
        />
        <span>全部设备</span>
      </div>
      <div :class="show == 1 ? 'list-item choosen' : 'list-item '" @click="sbclick(1)">
        <img
          :src="show == 1 ?require('../../assets/equipment/sxt.png'):require('../../assets/equipment/shexiangtou.png')"
        />
        <span>摄像头</span>
      </div>
      <div :class="show == 2 ? 'list-item choosen' : 'list-item '" @click="sbclick(2)">
        <img
          :src="show == 2 ?require('../../assets/equipment/xiaofangshuan-nav.png'):require('../../assets/equipment/xfs.png')"
        />
        <span>消防栓</span>
      </div>
      <div :class="show == 3 ? 'list-item choosen' : 'list-item '" @click="sbclick(3)">
        <img
          :src="show == 3 ?require('../../assets/equipment/qg.png'):require('../../assets/equipment/chuanbo.png')"
        />
        <span>船舶</span>
      </div>
      <div :class="show == 4 ? 'list-item choosen' : 'list-item '" @click="sbclick(4)">
        <img
          :src="show == 4 ?require('../../assets/equipment/xzcl.png'):require('../../assets/equipment/zhuangxiecheliang.png')"
        />
        <span>装卸车辆</span>
      </div>
      <div :class="show == 5 ? 'list-item choosen' : 'list-item '" @click="sbclick(5)">
        <img
          :src="show == 5 ?require('../../assets/equipment/dzwl.png'):require('../../assets/equipment/dianziweilan.png')"
        />
        <span>电子围栏</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: 0
    };
  },
  components: {},
  methods: {
    sbclick(val) {
      this.show = val;
      switch (val) {
        case 0:
          document
            .getElementById("iframe")
            .contentWindow.MMSDT.coverage(["all"], "all");
          this.show = 0;

          break;
        case 1:
          document
            .getElementById("iframe")
            .contentWindow.MMSDT.coverage(["A2"], "all");
          this.show = 1;
          break;
        case 2:
          document
            .getElementById("iframe")
            .contentWindow.MMSDT.coverage(["A3"], "all");
          this.show = 2;
          break;
        case 3:
          document
            .getElementById("iframe")
            .contentWindow.MMSDT.coverage(["A4"], "all");
          this.show = 3;
          break;
        case 4:
          document
            .getElementById("iframe")
            .contentWindow.MMSDT.coverage(["A6"], "all");
          this.show = 4;
          break;
        case 5:
          document
            .getElementById("iframe")
            .contentWindow.MMSDT.coverage(["A5"], "all");
          this.show = 5;
          break;
      }
    }
  }
};
</script>

<style scoped lang="less">
.equ-show {
  width: 25%;
  height: 100%;
  color: rgb(152, 254, 249);
  font-size: 12px;
  .list {
    display: flex;
    width: 100%;
    justify-content: space-around;
    flex-wrap: wrap;
    .list-item {
      width: 30%;
      display: flex;
      cursor: pointer;
      flex-direction: column;
      align-items: center;
      margin-top: 0.5vh;
      &.choosen {
        color: #f39104;
      }
    }
  }
}
</style>
